(() => {
	angular.module('main').component('adminHome', adminHome());

	adminHome.$inject = [];

	function adminHome() {
		return {
			template: require('./adminHome.component.html'),
			controller: 'AdminController'
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/home/adminHome.component.js